import { cn } from "@shadcn/lib/utils";
import { Link } from "@tanstack/react-router";
import { ChevronRight, LucideIcon } from "lucide-react";

type EmptyCard3Props = {
	title: React.ReactNode;
	description?: React.ReactNode;
	onClick?: () => void;
	to?: string;
	linkProps?: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;
	iconClassName?: string;
	iconContainerClassName?: string;
} & ({ icon: LucideIcon; image?: never } | { image: string; icon?: never });

export const EmptyCard3 = (props: EmptyCard3Props) => {
	const { icon: Icon, image, title, description, to, onClick, linkProps, iconClassName, iconContainerClassName } = props;

	const Element = to
		? {
				Component: Link,
				props: {
					to,
				},
			}
		: onClick
			? {
					Component: "button",
					props: {
						onClick,
					},
				}
			: linkProps
				? {
						Component: "a",
						props: {
							...linkProps,
						},
					}
				: {
						Component: "div",
						props: {},
					};

	return (
		<Element.Component
			className={cn("border-border hover:bg-accent/20 flex cursor-pointer items-start border-t py-5 transition-colors md:py-6 w-full", {
				"items-center leading-5": !description,
			})}
			{...Element.props}
		>
			<a></a>
			<div className={cn("flex items-center justify-center md:h-12 md:w-12 md:rounded-md md:border md:shadow-xs", iconContainerClassName)}>
				{Icon && <Icon className={cn("size-6", iconClassName)} />}
				{image && <img src={image} alt="" className="size-12 object-cover" />}
			</div>
			<div className="mx-4 flex-1">
				<h3 className="text-card-foreground text-base font-semibold -mt-1 flex justify-between font-breit">{title}</h3>
				{description && <p className="text-muted-foreground text-sm">{description}</p>}
			</div>
			{Element.Component !== "div" && <ChevronRight className="h-5 w-5" />}
		</Element.Component>
	);
};
